module.exports = __webpack_public_path__ + "media/assets/images/landing/ведомство_8-7d45f616954322fffef3865e8c5458db.png";